
import {
    GET_SNOW_SKI
} from '../actions/snowSkiActions';

const initialState = {
    resorts: [],
    snowSkiIsLoading: false,
    lastError: undefined
};

export function snowSki(state = initialState, action) {
    switch (action.type) {
        case GET_SNOW_SKI.pending:
        {
            return {
                ...state,
                snowSkiIsLoading: true
            };
        }
        case GET_SNOW_SKI.fulfilled:
        {
            return {
                ...state,
                lastError: undefined,
                snowSkiIsLoading: false,
                resorts: action.payload
            };
        }
        case GET_SNOW_SKI.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                snowSkiIsLoading: false
            };
        }
    }

    return state;
}
